export var WithdrawalMethods;
(function (WithdrawalMethods) {
    WithdrawalMethods["BOG_WIRE"] = "BOG_WIRE";
    WithdrawalMethods["BOG_CARD"] = "BOG_CARD";
    WithdrawalMethods["FIREBLOCKS"] = "FIREBLOCKS";
    WithdrawalMethods["BITNET_INTERNAL"] = "BITNET_INTERNAL";
})(WithdrawalMethods || (WithdrawalMethods = {}));
//# sourceMappingURL=withdrawalMethods.js.map